<template>
  <div>
    <CAlert
      v-if="reqResponse.message"
      class="mt-1 w-100"
      :color="reqResponse.type"
      :show="!!reqResponse.message"
    >
      {{ reqResponse.message }}
    </CAlert>
    <LazyLoadSelect
      :classes="[
        {
          'is-invalid': v$.form.room.$error || reqResponse.errors['kiosk_room']
        },
        'mb-3'
      ]"
      :is-multiple="false"
      :selected="form.room"
      type="locations"
      :default="defaultKioskValue"
      :prepend-items="[defaultKioskValue]"
      placeholder="From location for Kiosk"
      @changed="
        (value) => {
          form.room = value
        }
      "
    >
      <template #footer>
        <div
          v-if="v$.form.$error && v$.form.room.required.$invalid"
          class="invalid-feedback"
        >
          This field is required
        </div>
        <div v-if="reqResponse.errors['kiosk_room']" class="invalid-feedback">
          {{ reqResponse.errors["kiosk_room"][0] }}
        </div>
      </template>
    </LazyLoadSelect>
    <div class="w-100 text-center">
      <button
        class="btn bg-gradient-blue text-white py-2 px-4 fw-bold"
        @click="submit"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import LazyLoadSelect from "@/components/LazyLoadSelect.vue"
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
import { mapGetters } from "vuex"

export default {
  name: "CreateKioskForm",
  components: {
    LazyLoadSelect
  },
  emits: ["kioskCreated"],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      form: {
        room: null
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  validations: {
    form: {
      room: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "authentication/user"
    }),
    isValid() {
      return !this.v$.form.$invalid
    },
    defaultKioskValue() {
      return {
        label: "Me (your name will be the FROM location)",
        value: {
          id: this.currentUser.id,
          type: "App\\Models\\User"
        }
      }
    }
  },
  methods: {
    submit() {
      if (this.isValid) {
        const kiosk = {
          kiosk_room: this.form.room.value.id, //to delete after BE update
          kiosk_type_id: this.form.room.value.id,
          kiosk_type: this.form.room.value.type
        }
        this.$store
          .dispatch("kiosks/createKiosk", kiosk)
          .then(() => {
            this.resetForm()
            this.setSuccessResponse("Successfully created.")
            setTimeout(() => {
              this.$emit("kioskCreated")
              this.resetResponseMessages()
            }, 800)
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
          })
      } else {
        this.v$.$touch()
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetForm() {
      this.form.room = this.defaultKioskValue
      this.v$.$reset()
    }
  }
}
</script>
